(function () {
  // Wait for JS files to be present
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function initGsapAnimations() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    // Clear existing triggers (important for theme editor & dynamic reloads)
    ScrollTrigger.getAll().forEach(t => t.kill());

    // EXAMPLE 1: Animate your image-with-text section (using your custom class)
    const stuartWilson = document.querySelector('.section--stuart_wilson'); // whatever custom class you used
    if (stuartWilson) {
      const stuartWilsonImage = stuartWilson.querySelector('.image-block');

      if (stuartWilson) {
        gsap.from(stuartWilsonImage, {
          y: "150%",
          duration: 0.6,
          ease: 'back.out(1.6)',
          scrollTrigger: {
            trigger: stuartWilson,
            start: 'top 75%',
            toggleActions: 'play none none reverse'
          }
        });
      }
    }

gsap.utils.toArray(".animation-reveal, .hero-wrapper .group-block, .hero-wrapper .image-block, .metlakatla_logo img").forEach((reveal) => {
  gsap.fromTo(
    reveal,
    {
      y: 200,
      autoAlpha: 0,
    },
    {
      y: 0,
      autoAlpha: 1,
      duration: 1,
      ease: "power4.out",
      scrollTrigger: {
        trigger: reveal,
        start: "top bottom",
        toggleActions: "play none none reverse",
        markers: false,
      },
    }
  );
});


  }

  // Initial page load
  ready(initGsapAnimations);

  
})();